import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {FormFieldRegistrationRelations} from "../../models/formfield_registration_relations";
import Helpers from "../../utils/helpers";

@Injectable()
export class FormFieldRegistrationsControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getFormFieldRegistrationsRelationsList(serviceId: string): Observable<FormFieldRegistrationRelations[][]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/formfields_registration_relations") as Observable<FormFieldRegistrationRelations[][]> ;
  }

  public updateFormFieldRegistrations(serviceId: string, formFieldRegistrationRelations: FormFieldRegistrationRelations) {
    Helpers.trimRecursiveObj(formFieldRegistrationRelations);
    const body = JSON.stringify(formFieldRegistrationRelations);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/formfields_registration_relations", body);
  }
}
